/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketpricetoolowerror4Inputs */

const en_ticketpricetoolowerror4 = /** @type {(inputs: Ticketpricetoolowerror4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paid tickets cost at least €0.50.`)
};

const de_ticketpricetoolowerror4 = /** @type {(inputs: Ticketpricetoolowerror4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bezahlte Tickets kosten mindestens 0,50 €.`)
};

/**
* | output |
* | --- |
* | "Paid tickets cost at least €0.50." |
*
* @param {Ticketpricetoolowerror4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketpricetoolowerror4 = /** @type {((inputs?: Ticketpricetoolowerror4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketpricetoolowerror4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketpricetoolowerror4(inputs)
	return de_ticketpricetoolowerror4(inputs)
});
export { ticketpricetoolowerror4 as "ticketPriceTooLowError" }